
import goalWebsiteIcon from '../../media/goal-website.svg';
import goalPhoneIcon from '../../media/goal-phone.svg';
import goalLocationIcon from '../../media/goal-location.svg';
import goalWebsiteImg from '../../media/goal-website-img.svg';
import goalPhoneImg from '../../media/goal-phone-img.svg';
import goalLocationImg from '../../media/goal-location-img.svg';
import goalSelectedImg from '../../media/checkmark.svg';

export const Goals = {
  IncreaseWebsiteVisit: {
    value: 'IncreaseWebsiteVisit',
    title: _TL_('Visits to my website'),
    isRecommended: true,
  },
  IncreaseCallToBusiness: {
    value: 'IncreaseCallToBusiness',
    title: _TL_('Phone calls to my business'),
    isRecommended: false,
  },
  IncreaseBusinessLocationVisit: {
    value: 'IncreaseBusinessLocationVisit',
    title: _TL_('Visits to my physical business locations'),
    isRecommended: false,
  },
};

export const getStepGoalOptionsImages = isShowIcon => ({
  IncreaseWebsiteVisit: {
    imageSrc: isShowIcon? goalWebsiteIcon : goalWebsiteImg,
    alt: _TL_('increase website visits icon'),
  },
  IncreaseCallToBusiness: {
    imageSrc: isShowIcon ? goalPhoneIcon: goalPhoneImg,
    alt: _TL_('increase phone calls icon'),
  },
  IncreaseBusinessLocationVisit: {
    imageSrc: isShowIcon? goalLocationIcon: goalLocationImg,
    alt: _TL_('increase location visits icon'),
  },
  GoalSelected: {
    imageSrc: goalSelectedImg,
    alt: _TL_('goal selected icon'),
  },
});

export const campaignGoals = ['IncreaseWebsiteVisit', 'IncreaseCallToBusiness', 'IncreaseBusinessLocationVisit'];
